import { createSlice } from '@reduxjs/toolkit'

export interface ModalState {
  title: string
  isOpen: boolean
  content: React.ReactNode
  width?: number
}

const initialState: ModalState = {
  title: '',
  isOpen: false,
  content: null,
  width: 850,
}

const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    openModal: (state, { payload }) => {
      state.isOpen = true
      state.content = payload.content
      state.title = payload.title
      if (payload.width) {
        state.width = payload.width
      }
      return state
    },
    closeModal: (state) => {
      state.isOpen = false
      state.content = null
      state.title = ''
      state.width = 850
      return state
    },
  },
})

export const { openModal, closeModal } = modalSlice.actions

export default modalSlice.reducer
